import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap';

export const Confirmation = ({ text, openEmitter, headerText, modalSize }) => {
  const [isOpen, setOpen] = useState(false);
  const [event, setEvent] = useState(null);

  openEmitter.addEventListener('open', e => {
    setEvent(e);
    setOpen(true);
  });

  const toggle = () => {
    event.promise.reject({});
    setOpen(!isOpen);
  };

  const onClick = () => {
    setOpen(false);
    event.promise.resolve();
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size={modalSize}>
      <ModalHeader toggle={toggle}>{headerText}</ModalHeader>
      <ModalBody>
        <div className="mb-4">{text}</div>
        <div className="text-center">
          <Button color="primary" outline onClick={onClick}>
            Confirm
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

Confirmation.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  openEmitter: PropTypes.object.isRequired,
  headerText: PropTypes.string,
  modalSize: PropTypes.string,
};

Confirmation.defaultProps = {
  headerText: 'Confirmation',
  modalSize: 'sm',
};
